import React, { useState } from 'react';
import { HomePage } from './pages/HomePage';
import { AssetLabelsPage } from './pages/AssetLabelsPage';
import { SimplifiedPage } from './pages/SimplifiedPage';
import { ServicesPage } from './pages/ServicesPage';
import { AboutPage } from './pages/AboutPage';
import { TeamPage } from './pages/TeamPage';
import { PoliciesPage } from './pages/PoliciesPage';
import { DeliverPage } from './pages/DeliverPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { MegaMenuPage } from './pages/MegaMenuPage';
import { SampleRequestModal } from './components/SampleRequestModal';
import { HelpCircle, X, Phone, Mail, MessageSquare } from 'lucide-react';
function HelpWidget() {
  const [open, setOpen] = useState(false);
  return <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-id="element-0">
      {open && <div className="bg-white rounded-2xl shadow-2xl border border-slate-100 p-5 w-72 mb-1" data-id="element-1">
          <div className="flex items-center justify-between mb-4" data-id="element-2">
            <h3 className="font-bold text-[#0A1628]" data-id="element-3">How can we help?</h3>
            <button onClick={() => setOpen(false)} className="text-slate-400 hover:text-slate-600 transition-colors" data-id="element-4">
              <X className="h-4 w-4" data-id="element-5" />
            </button>
          </div>
          <div className="space-y-2" data-id="element-6">
            <a href="tel:01384243155" className="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition-colors group" data-id="element-7">
              <div className="h-9 w-9 bg-[#0052CC]/10 rounded-lg flex items-center justify-center" data-id="element-8">
                <Phone className="h-4 w-4 text-[#0052CC]" data-id="element-9" />
              </div>
              <div data-id="element-10">
                <p className="text-sm font-semibold text-[#0A1628]" data-id="element-11">Call us</p>
                <p className="text-xs text-slate-500" data-id="element-12">01384 243155</p>
              </div>
            </a>
            <a href="mailto:sales@industriallabels.co.uk" className="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition-colors" data-id="element-13">
              <div className="h-9 w-9 bg-[#0052CC]/10 rounded-lg flex items-center justify-center" data-id="element-14">
                <Mail className="h-4 w-4 text-[#0052CC]" data-id="element-15" />
              </div>
              <div data-id="element-16">
                <p className="text-sm font-semibold text-[#0A1628]" data-id="element-17">Email us</p>
                <p className="text-xs text-slate-500" data-id="element-18">
                  <Mail className="h-5 w-5 text-slate-500 flex-shrink-0" data-id="element-19" />
                  sales@industriallabels.co.uk
                </p>
              </div>
            </a>
            <a href="/policies" className="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50 transition-colors" data-id="element-20">
              <div className="h-9 w-9 bg-[#0052CC]/10 rounded-lg flex items-center justify-center" data-id="element-21">
                <MessageSquare className="h-4 w-4 text-[#0052CC]" data-id="element-22" />
              </div>
              <div data-id="element-23">
                <p className="text-sm font-semibold text-[#0A1628]" data-id="element-24">
                  FAQs & Policies
                </p>
                <p className="text-xs text-slate-500" data-id="element-25">
                  Common questions answered
                </p>
              </div>
            </a>
          </div>
        </div>}
      <button onClick={() => setOpen(!open)} className="h-14 w-14 bg-[#0052CC] text-white rounded-full shadow-lg hover:bg-[#0040A0] transition-colors flex items-center justify-center" aria-label="Help" data-id="element-26">
        {open ? <X className="h-6 w-6" data-id="element-27" /> : <HelpCircle className="h-6 w-6" data-id="element-28" />}
      </button>
    </div>;
}
export function App() {
  const [isSampleModalOpen, setIsSampleModalOpen] = useState(false);
  const openSampleModal = () => setIsSampleModalOpen(true);
  const closeSampleModal = () => setIsSampleModalOpen(false);
  const path = window.location.pathname;
  let content;
  if (path === '/products/asset-labels') {
    content = <AssetLabelsPage onOpenSampleModal={openSampleModal} data-id="element-29" />;
  } else if (path === '/simplified') {
    content = <SimplifiedPage data-id="element-30" />;
  } else if (path === '/services') {
    content = <ServicesPage onOpenSampleModal={openSampleModal} data-id="element-31" />;
  } else if (path === '/about') {
    content = <AboutPage onOpenSampleModal={openSampleModal} data-id="element-32" />;
  } else if (path === '/about/team' || path === '/team') {
    content = <TeamPage onOpenSampleModal={openSampleModal} data-id="element-33" />;
  } else if (path === '/policies') {
    content = <PoliciesPage onOpenSampleModal={openSampleModal} data-id="element-34" />;
  } else if (path === '/how-we-deliver') {
    content = <DeliverPage onOpenSampleModal={openSampleModal} data-id="element-35" />;
  } else if (path === '/resources') {
    content = <ResourcesPage onOpenSampleModal={openSampleModal} data-id="element-36" />;
  } else if (path === '/mega-menu') {
    content = <MegaMenuPage data-id="element-37" />;
  } else {
    content = <HomePage onOpenSampleModal={openSampleModal} data-id="element-38" />;
  }
  return <>
      {content}
      <SampleRequestModal isOpen={isSampleModalOpen} onClose={closeSampleModal} data-id="element-39" />
      <HelpWidget data-id="element-40" />
    </>;
}